window.FazendaRP_Logo = "assets/logo_fazenda_rio_peixe.png";
window.FazendaRP_NomeFazenda = "Fazenda Rio do Peixe";
